<template>
  <div>
    <b-field :type="validator.inputFieldClass" :message="validator.inputFieldMessage" expanded>
      <b-taginput :disabled="!isEditable" :readonly="!isEditable" v-model="values" :data="options" @input="announce"
        autocomplete open-on-focus placeholder="Select a value">
      </b-taginput>
    </b-field>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters(['context']),
    isEditable () {
      if (this.attribute.rule.attribute.code === 'identifier' && this.context.isMerchant()) return false
      if (this.attribute.rule.attribute.editable_by === 'any' || this.attribute.rule.attribute.editable_by === null) return true
      if (this.context.isMerchant() && this.attribute.rule.attribute.editable_by === 'retailer') return true
      if (this.context.isSupplier() && this.attribute.rule.attribute.editable_by === 'brand') return true
      return false
    },
    hasOptions () {
      return Boolean(this.attribute.rule.rule_validators[0]?.values.length)
    },
    options () {
      return this.attribute.rule.rule_validators[0]?.values
    },
    validator () {
      const validator = {
        inputFieldClass: null,
        inputFieldMessage: null
      }
      const hasValues = Array.isArray(this.values) && this.values.length > 0

      // Required field check
      if (this.attribute.rule.is_required === true && !hasValues) {
        return {
          inputFieldClass: 'is-warning',
          inputFieldMessage: 'At least one value is required for this field.'
        }
      }

      // Options expected but none available
      if (!this.hasOptions && (!this.options || this.options.length === 0) && hasValues) {
        return {
          inputFieldClass: 'is-warning',
          inputFieldMessage: 'This field has no available options, but values have been selected.'
        }
      }

      // Valid options check (only if options are defined)
      if (hasValues && this.hasOptions) {
        const invalidValues = this.values.filter(val => !this.options.includes(val))
        if (invalidValues.length > 0) {
          return {
            inputFieldClass: 'is-warning',
            inputFieldMessage: 'Some selected values are not allowed. Please select valid options.'
          }
        }
      }
      // Change detection
      if (JSON.stringify(this.originalValue) !== JSON.stringify(this.values)) {
        return {
          inputFieldClass: 'is-info',
          inputFieldMessage: null
        }
      }
      return validator
    }
  },
  data () {
    return {
      originalValue: [],
      values: []
    }
  },
  methods: {
    announce () {
      this.$emit('input', {
        attribute: {
          code: this.attribute.rule.attribute.code
        },
        value: this.values.join('|')
      })
    }
  },
  mounted () {
    if (this.attribute.value) {
      // determine if value exists
      if (this.attribute.value?.values?.length) {
        const rawValue = this.attribute.value.values[0].value

        if (Array.isArray(rawValue)) {
          this.originalValue = [...rawValue]
          this.values = [...rawValue]
        } else if (typeof rawValue === 'string' && rawValue.includes('|')) {
          const splitValues = rawValue.split('|')
          this.originalValue = splitValues
          this.values = splitValues
        } else {
          this.originalValue = [rawValue]
          this.values = [rawValue]
        }
      }
    }
  },
  props: {
    attribute: {
      type: Object,
      required: true
    }
  }
}
</script>
